import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button, Form, FormGroup, FormText, Input, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import LoadingSpin from "react-loading-spin";

export class DormAssign extends Component {
    static displayName = DormAssign.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            loadingFlag: true,
            closedFlag: false,
            dormAssignData: [],
            fullDormAssign: [],
            dormOverviewData: [],
            buildVal: "DEFAULT",
            buildName: "",
            buildList: [],
            roomVal: "DEFAULT",
            roomNumber: "",
            stuA: "",
            stuB: "",
            stuC: "",
            stuD: "",
            roomList: [],
            requestModal: false,
            requestMessage: "",
            resLifeViewRoom: "DEFAULT",
            allStu: [],
            viewType: "" //true for employee, false for student
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            viewType: data.level.substring(0, 8) != "STUDENTS" && data.level.substring(0, data.level.indexOf("-") - 1) != "INFO TECHNOLOGY" ? true : false
        }, () => {
            this.recordComingHere();
            this.testPermission();
        });
        
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "1042",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1042"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getOverviewData();
        this.getTableData();
        
    }

    async getTableData() {//This should only be retrieving data that's relevant to the authenticated user
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
        }
        const response = await fetch('GetDormAssignData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            dormAssignData: data,
            loadingFlag: false
        })
        localStorage.setItem("lastFetch", moment());
        if (this.state.viewType) {
            this.getAllAssign();
        }
    }

    async getOverviewData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
        }
        const response = await fetch('GetDormOverviewData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            dormOverviewData: data
        }, () => {
            if (!this.state.viewType) {
                this.getAllStudents();
            }
        })
        var buildVAR = [];
        data.map((item) => {
            var findItem = buildVAR.find((x) => x.buildCode === item.buildCode);
            if (!findItem) buildVAR.push(item);
        })
        var closedBOOL = false;
        if (data.length < 1) closedBOOL = true;
        this.setState({
            buildList: buildVAR,
            closedFlag: closedBOOL
        })
        localStorage.setItem("lastFetch", moment());
    }

    async getAllAssign() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('DormAllAssign', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            fullDormAssign: data
        })
    }

    componentDidMount() {
        
    }

    async getAllStudents() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('SelfAssignAllStu', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            allStu: data
        })
    }

    async submitButton(e) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        e.preventDefault();
        let errorCount = 0;
        var internalRoomSize = this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize;
        var roomID = this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomID;
        var badStudents = [null, ""];
        
        //if (internalRoomSize > "1") {
        //    if (
        //        internalRoomSize == "2"
        //        && (badStudents.indexOf(this.state.stuB) > -1 || !this.state.stuB.includes("@hood.edu"))) {
        //        errorCount = errorCount+1;
        //    }
        //    else if (internalRoomSize == "3"
        //        && (badStudents.indexOf(this.state.stuB) > -1 || !this.state.stuB.includes("@hood.edu")
        //            || badStudents.indexOf(this.state.stuC) > -1 || !this.state.stuC.includes("@hood.edu"))
        //    ) {
        //        errorCount = errorCount+1;
        //    }
        //    else if (internalRoomSize == "4"
        //        && (badStudents.indexOf(this.state.stuB) > -1 || !this.state.stuB.includes("@hood.edu")
        //        || badStudents.indexOf(this.state.stuC) > -1 || !this.state.stuC.includes("@hood.edu")
        //        || badStudents.indexOf(this.state.stuD) > -1 || !this.state.stuD.includes("@hood.edu")
        //        )) {
        //        errorCount = errorCount+1;
        //    }
        //}
        if (errorCount === 0) {
            //var studentList = this.state.stuB + ";" + this.state.stuC + ";" + this.state.stuD + ";";
            let toSend = {
                userLevel: this.state.returnable.level,
                stuA: this.state.stuA,
                stuB: this.state.stuB,
                stuC: this.state.stuC,
                stuD: this.state.stuD
            }
            const response = await fetch('CheckSelfAssignReq', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            var filteredStu = data.filter(x => x.pcid != this.state.returnable.pcid)
            let confirmMessage = "You are about to request " + this.state.buildName + " room " + roomID;
            switch (internalRoomSize) {
                case "2":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + " as a roommate."
                    break;
                case "1":
                    confirmMessage = confirmMessage + "."
                    break;
                case "3":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + " and " + filteredStu[1].stuName + " as roommates."
                    break;
                case "4":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + ", " + filteredStu[1].stuName + ", and " + filteredStu[2].stuName + " as roommates."
                    break;
                default:
                    confirmMessage = confirmMessage + ""
                    break;
            }
            confirmMessage = confirmMessage + " Are you sure?";
            if (filteredStu[0].email == "ERROR") {
                let errorMessage = "There was a problem with your submission. Please confirm that you are making this request at the proper time for your class, that all of your requested roommates are current students, and that none of your requested roommates are already requested in a different room."
                this.setState({
                    requestModal: true,
                    requestMessage: errorMessage
                })
            }
            else {
                this.setState({
                    requestModal: true,
                    requestMessage: confirmMessage
                })
            }
        }
        else {
            let errorMessage = "There was a problem with your submission. Please confirm that you have entered your requested roommates' full Hood email address, not their names or their usernames or their ID numbers."
            this.setState({
                requestModal: true,
                requestMessage: errorMessage
            })
        }
    }

    async confirmSubmit() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level, 
            stuA: this.state.stuA,
            stuB: this.state.stuB,
            stuC: this.state.stuC,
            stuD: this.state.stuD,
            build: this.state.buildVal,
            room: this.state.roomNumber
        }
        const response = await fetch('DormSelfAssignConfirmReq', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        if (data.success == 0) {
            this.setState({
                requestModal: true,
                requestMessage: data.returnMessage
            })
            
        }
        //this.requestModalFlip();
        this.getOverviewData();
        this.getTableData();
    }

    async approveRequest() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level,
            pk: this.state.dormAssignData[0].pk,
            command: "A"
        }
        const response = await fetch('DormRequestStuAction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            dormAssignData: data
        })

    }

    async denyRequest() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level,
            pk: this.state.dormAssignData[0].pk,
            command: "D"
        }
        const response = await fetch('DormRequestStuAction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            dormAssignData: []
        })
        this.getOverviewData();
    }

    async confirmRoom(pk) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level,
            pk: pk
        }
        if (this.state.viewType) {
            const response = await fetch('DormRequestConfirm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
        }
        this.setState({
            resLifeViewRoom: "DEFAULT"
        })
        this.getAllAssign();
        this.getOverviewData();
    }

    async clearRoom(pk,roomOptional) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level,
            pk: pk,
            roomOp: roomOptional
        }
        console.log("toSend: " + JSON.stringify(toSend))
        const response = await fetch('ResLifeClearRoom', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            resLifeViewRoom: "DEFAULT"
        })
        this.getAllAssign();
        this.getOverviewData();
    }

    async finalize() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('DormAssignFinalize', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getAllAssign();
        this.getOverviewData();
        this.setState({
            buildVal: "DEFAULT",
            resLifeViewRoom: "DEFAULT"
        })
    }

    overviewTable() {
        return (<div>
            <Table>
                <thead>
                    <tr>
                        <th>Room number</th>
                        <th>Room size</th>
                        <th>Room Attributes</th>
                        <th>Availability</th>
                        {this.state.viewType && <th></th>}
                        {/*<th>Occupancy List</th>*/}
                    </tr>
                </thead>
                <tbody>
                    {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal).map(item => (
                        <tr>
                            <td>{item.roomID}</td>
                            <td>{item.roomSize}</td>
                            <td>{item.roomAttr}</td>
                            <td style={{ color: (item.roomStatus.includes('Available') ? 'green' : 'red') }}>{item.roomStatus}</td>
                            {this.state.viewType && !item.roomStatus.includes('Available') ? <td><Button outline onClick={() => this.setState({ resLifeViewRoom: item.roomID })}>View</Button></td> : this.state.viewType && <td></td>}
                            {/*<td>{JSON.stringify(item.claimantList)}</td>*/}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }

    resLifeTableManage() {
        let roomListProcessed = [this.state.buildName + " " + this.state.resLifeViewRoom + "A",
            this.state.buildName + " " + this.state.resLifeViewRoom + "B",
            this.state.buildName + " " + this.state.resLifeViewRoom + "C",
            this.state.buildName + " " + this.state.resLifeViewRoom + "D",]
        let thisRoomProcessed = this.state.fullDormAssign.filter(function (e) { return this.indexOf(e.room) >= 0 }, roomListProcessed)
        return (
            <div>
                <h3>Viewing: {this.state.buildName} {this.state.resLifeViewRoom}</h3>{'    '}<Button outline onClick={() => this.setState({ resLifeViewRoom: "DEFAULT" })}>Go Back</Button>
                <br />
                <br />
                <Table>
                    <thead>
                        <tr>
                            <th>Room</th>
                            <th>Student</th>
                            <th>Status</th>
                            {thisRoomProcessed[0].stuStatus != "Confirmed!" && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {thisRoomProcessed.map(item => (
                            <tr>
                                <td>{item.room}</td>
                                <td>{item.stuName}</td>
                                <td>{item.stuStatus}</td>
                                {item.stuStatus != "Confirmed!" && <td><Button color="warning" outline onClick={(e) => this.clearRoom(item.pk, item.room)}>Clear This Bed</Button></td>}
                            </tr>
                        )) }
                    </tbody>
                </Table>
                <br />
                {thisRoomProcessed.length > 0 && <div className="rightAlignCustom"><Button outline color="danger" onClick={() => this.clearRoom(thisRoomProcessed[0].pk,"")}>Clear this room</Button></div>}&nbsp;
                {thisRoomProcessed.length == thisRoomProcessed.filter((x) => x.stuStatus == "Approved").length && thisRoomProcessed.length > 0 && 
                    <div className="rightAlignCustom"><Button outline color="success" onClick={() => this.confirmRoom(thisRoomProcessed[0].pk)}>Confirm This Room</Button></div>}
            </div>
        )
    }

    buildSelect() {
        return (
            <div className="quarterOfParent">
            <Form>
                <Input type="select" name="building_select" id="building_select" value={this.state.buildVal} onChange={(e) => {
                        this.setState({
                            buildVal: e.target.value,
                            roomVal: "DEFAULT",
                            buildName: e.target.options[e.target.selectedIndex].text,
                            stuA: "",
                            stuB: "",
                            stuC: "",
                            stuD: ""
                        })
                }}>
                <option value="DEFAULT" disabled>Select Building</option>
                        {this.state.buildList.map(item => (
                            <option key={ item.clientPK} value={item.buildCode}>{item.buildName}</option>
                ))}
                    </Input>
                </Form>
            </div>
        )
    }

    resLifeView() {
        return (<div>
            {this.state.resLifeViewRoom == "DEFAULT" && this.buildSelect()}&emsp;&emsp;{this.state.buildVal != "DEFAULT" && <div className="rightAlignCustom"><Button onClick={() => this.finalize() }>Finalize All Confirmed Rooms</Button></div>}<p />
            {this.state.buildVal != "DEFAULT" && this.state.resLifeViewRoom == "DEFAULT" && this.overviewTable()}
            {this.state.buildVal != "DEFAULT" && this.state.resLifeViewRoom != "DEFAULT" && this.resLifeTableManage()}
        </div>)
    }

    studentView() {
        if (!this.state.loadingFlag) {
            if (this.state.dormAssignData.length > 0) {
                return (<div>
                    <h3>You have been requested to be a roommate with the following students in {this.state.dormAssignData[0].room.slice(0, -1)}</h3><p />
                    <Table>
                        <thead>
                            <tr>
                                <th>Room</th>
                                <th>Student</th>
                                <th>Availability Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.dormAssignData.map(item => (
                                <tr>
                                    <td>{item.room}</td>
                                    <td>{item.pcid == this.state.returnable.pcid ? "You!" : item.stuName}</td>
                                    <td>{item.stuStatus == "Awaiting Response..." && item.pcid == this.state.returnable.pcid ?
                                        <div><Button outline onClick={() => this.approveRequest()}>Approve</Button><Button outline onClick={() => this.denyRequest()}>Deny</Button></div>
                                        : item.stuStatus}</td>
                                    <td>{item.pcid == this.state.returnable.pcid && item.stuStatus == "Approved" ? <Button outline color="danger" onClick={() => this.denyRequest()} >Remove Me</Button> :<div></div> }</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>)
            }
            else {
                return (
                    <div>
                        <Modal isOpen={this.state.requestModal} toggle={this.requestModalFlip.bind(this)}>
                            <ModalHeader toggle={this.requestModalFlip.bind(this)}></ModalHeader>
                            <ModalBody>
                                {this.state.requestMessage}
                            </ModalBody>
                            <ModalFooter>
                                {!this.state.requestMessage.includes("Your request") && <Button color="success" onClick={() => { this.confirmSubmit() }}>Confirm</Button>}
                            </ModalFooter>
                        </Modal>
                        <span>I am requesting:</span><p />
                        <Form>
                            <FormGroup>
                                <Label>Building: </Label>
                                {this.buildSelect()}
                            </FormGroup>
                            {this.state.buildVal != "DEFAULT" &&
                                <FormGroup>
                                    <Label>Room: </Label>
                                    <div className="quarterOfParent">
                                        <Input type="select" name="room_input" id="room_input" value={this.state.roomVal} onChange={(e) => this.setState({
                                            roomVal: e.target.value,
                                            roomNumber: e.target.options[e.target.selectedIndex].text,
                                            stuA: "",
                                            stuB: "",
                                            stuC: "",
                                            stuD: ""
                                        })}>
                                            <option value="DEFAULT" disabled>Select... </option>
                                            {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal && build.roomStatus != "Confirmed" &&
                                                (!build.roomStatus.includes("1/1") && !build.roomStatus.includes("2/2") && !build.roomStatus.includes("3/3") && !build.roomStatus.includes("4/4"))).map(item => (
                                                <option key={item.clientPK} value={item.clientPK}>{item.roomID}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 0 &&
                                <div>
                                    < FormGroup >
                                        <Label>Roommate A</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "A")).length == 0 &&                                        
                                            <div className="quarterOfParent">
                                                <Input type="select" name="studentB" id="studentB" value={this.state.stuA} onChange={(e) => { this.setState({ stuA: e.target.value }) }}>
                                                    <option value="">No Preference</option>
                                                    {this.state.allStu.filter((stu) => stu.pcid != this.state.stuB && stu.pcid != this.state.stuC && stu.pcid != this.state.stuD).map(item => (
                                                        <option value={item.pcid}>{item.name}</option>
                                                    ))}
                                                </Input>
                                            </div>
                                        }
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "A")) != 0 &&
                                        <div>
                                                <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "A").stu}</strong><br />
                                                <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "A").email}</strong>
                                            </div>}
                                    </FormGroup>
                                </div>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 1 &&
                                <FormGroup>
                                    <Label>Roommate B</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "B")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentB" id="studentB" value={this.state.stuB} onChange={(e) => { this.setState({ stuB: e.target.value }) }}>
                                                <option value="">No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuC && stu.pcid != this.state.stuD).map(item => (
                                                    <option value={item.pcid}>{item.name}</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "B")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "B").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "B").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 2 &&
                                <FormGroup>
                                    <Label>Roommate C</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "C")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentC" id="studentC" value={this.state.stuC} onChange={(e) => this.setState({ stuC: e.target.value })}>
                                                <option value="">No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuB && stu.pcid != this.state.stuD).map(item => (
                                                    <option value={item.pcid}>{item.name}</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "C")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "C").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "C").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 3 &&
                                <FormGroup>
                                    <Label>Roommate D</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "D")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentD" id="studentD" value={this.state.stuD} onChange={(e) => this.setState({ stuD: e.target.value })}>
                                                <option value="">No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuC && stu.pcid != this.state.stuB).map(item => (
                                                    <option value={item.pcid}>{item.name}</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "D")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "D").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "D").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && <Button color="success" onClick={(e) => this.confirmSubmit(e)}>Submit</Button>}
                        </Form>
                        {this.state.buildVal != "DEFAULT" && this.overviewTable()}
                    </div>
                )
            }
        }
    }

    stuRequest() { //This may be abandonware, clean up?
        return (
            <div>
                
                <span>I am requesting:</span><p />
                <Form>
                    <FormGroup>
                        <Label>Building: </Label>
                        {this.buildSelect()}
                    </FormGroup>
                    {this.state.buildVal != "DEFAULT" &&
                        <FormGroup>
                            <Label>Room: </Label>
                            <div className="quarterOfParent">
                                <Input type="select" name="room_input" id="room_input" value={this.state.roomVal} onChange={(e) => this.setState({
                                    roomVal: e.target.value,
                                    roomNumber: e.target.options[e.target.selectedIndex].text,
                                    stuA: "",
                                    stuB: "",
                                    stuC: "",
                                    stuD: ""
                                })}>
                                    <option value="DEFAULT" disabled>Select... </option>
                                    {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal && build.roomStatus == "Available").map(item => (
                                        <option key={item.clientPK} value={item.clientPK}>{item.roomID}</option>
                                    ))}
                                </Input>
                            </div>
                        </FormGroup>
                    }
                    {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 1 &&
                        <FormGroup>
                            <Label>Roommate B Email</Label>
                            <div className="quarterOfParent"><Input type="text" name="studentB" id="studentB" value={this.state.stuB} onChange={(e) => { this.setState({ stuB: e.target.value }) }} /></div>
                        </FormGroup>
                    }
                    {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 2 &&
                        <FormGroup>
                            <Label>Roommate C Email</Label>
                            <div className="quarterOfParent"><Input type="text" name="studentC" id="studentC" value={this.state.stuC} onChange={(e) => this.setState({ stuC: e.target.value })} /></div>
                        </FormGroup>
                    }
                    {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 3 &&
                        <FormGroup>
                            <Label>Roommate D Email</Label>
                            <div className="quarterOfParent"><Input type="text" name="studentD" id="studentD" value={this.state.stuD} onChange={(e) => this.setState({ stuD: e.target.value })} /></div>
                        </FormGroup>
                    }
                    {this.state.roomVal != "DEFAULT" && <Button color="success" onClick={(e) => this.submitButton(e)}>Submit</Button>}
                </Form>
                {this.state.buildVal != "DEFAULT" && this.overviewTable()}
            </div>
        )
    }

    requestModalFlip() {
        this.setState({
            requestModal: !this.state.requestModal
        })
    }

    stuManage() {//This may be abandonware
        return (<div>
            <h3>You have been requested to be a roommate with the following students in {this.state.dormAssignData[0].room.slice(0, -1)}</h3><p />
            <Table>
                <thead>
                    <tr>
                        <th>Room</th>
                        <th>Student</th>
                        <th>Availability Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.dormAssignData.map(item => (
                        <tr>
                            <td>{item.room}</td>
                            <td>{item.pcid == this.state.returnable.pcid ? "You!" : item.stuName}</td>
                            <td></td>
                            <td>{item.stuStatus == "Awaiting Response..." && item.pcid == this.state.returnable.pcid ?
                                <div><Button outline onClick={() => this.approveRequest()}>Approve</Button><Button outline onClick={() => this.denyRequest() }>Deny</Button></div>
                                : item.stuStatus}</td>
                                
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        let displaySwitch = <div><LoadingSpin size="30px" primaryColor="#86d3ff" /></div>
        if (this.state.returnable.username != null) { if (this.state.viewType) { displaySwitch = this.resLifeView() } else { displaySwitch = this.studentView() } }
        //This is pretty scary, but if I just have the substring if statement at top level, the page crashes because it tries to evaluate the if statement before the user fetch can set its state
        return (<div>
            <Modal isOpen={this.state.requestModal} toggle={this.requestModalFlip.bind(this)}>
                <ModalHeader toggle={this.requestModalFlip.bind(this)}></ModalHeader>
                <ModalBody>
                    {this.state.requestMessage}
                </ModalBody>
                <ModalFooter>
                    {!this.state.requestMessage.includes("Your request") && <Button color="success" onClick={() => { this.confirmSubmit() }}>Confirm</Button>}
                </ModalFooter>
            </Modal>
            {this.state.closedFlag && <div>
                <h2>Our apologies, but self-assigning dorms has closed for the year.</h2><p />
                <h3>If you have any questions, please contact Residence Life.</h3>
            </div>}
            {!this.state.closedFlag && this.state.dormOverviewData.length > 0 ? displaySwitch : <LoadingSpin size="30px" primaryColor="#86d3ff" />}
        </div>);
    }
}
